// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"1b91c95d","311":"764b3f56","353":"78392895","583":"87727060","723":"45865deb","869":"50a110ee","947":"be77114e"}[chunkId] + ".chunk.css";
};